import { cn } from "@beweegbaas/ui";
import { createFileRoute } from "@tanstack/react-router";
import { containerStyles, Page } from "#/components/page";
import { m } from "#/paraglide/messages";

export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/contact")({
  component: SchoolContactPage,
});

function SchoolContactPage() {
  return (
    <Page>
      <div className={cn(containerStyles({ container: "default" }), "pb-10")}>
        <div className="prose">
          <p>{m["common.page_under_development"]()}</p>
        </div>
      </div>
    </Page>
  );
}
